import React, { Component } from "react";
import { withGoogleMap, GoogleMap, withScriptjs, Marker } from "react-google-maps";

import Config from '../../config';

class Map extends Component {
 constructor(props) {
  super(props);
  this.state = {
   mapPosition: {
    lat: this.props.center.lat,
    lng: this.props.center.lng
   },
   markerPosition: {
    lat: this.props.center.lat,
    lng: this.props.center.lng
   }
  };
 }

 onChange(event) {
  this.setState({ [event.target.name]: event.target.value });
 };

 shouldComponentUpdate(nextProps, nextState) {
  if (this.state.markerPosition.lat !== this.props.center.lat) {
   return true;
  } else if (this.props.center.lat === nextProps.center.lat) {
   return false;
  }
 }

 render() {
  const AsyncMap = withScriptjs(
   withGoogleMap(props => (
    <GoogleMap
     google={this.props.google}
     defaultZoom={this.props.zoom}
     defaultCenter={{
      lat: this.state.mapPosition.lat,
      lng: this.state.mapPosition.lng
     }}
    >
     {/*Marker*/}
     <Marker
      google={this.props.google}
      draggable={false}
      position={{
       lat: this.state.markerPosition.lat,
       lng: this.state.markerPosition.lng
      }}
     />
     <Marker />
    </GoogleMap>
   ))
  );
  let map;
  if (this.props.center.lat !== undefined) {
   map = (
    <AsyncMap
      googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + Config.googleMapsToken + "&libraries=places"}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: this.props.height }} />}
      mapElement={<div style={{ height: `100%` }} />}
     />
   );
  } else {
   map = <div style={{ height: this.props.height }} />;
  }
  return map;
 }
}
export default Map;



// WEBPACK FOOTER //
// ./websources/views/Establishments/Map.js